import { Kpi, KpiPercentage, ProductsCompareKpi, Rank } from '@models/Products';
import { FactRevenue } from '@utils/pageConfig/Types';
import { Periodicity } from '../time-period-selector/PeriodsTypes';
import { ProductType } from '@pages/product-analyzer/Product';
import { RelativePeriod } from '../comparison-period-selector/Types';
import { BaseTimePeriod } from '@services/FiltersTypes';

export interface ProductsCompareLocationState {
  timeFrame: Periodicity;
  factRevenue: FactRevenue;
  selectedPeriod: BaseTimePeriod;
  latestPeriod: BaseTimePeriod;
  currentProductType: ProductType;
  relativePeriod: RelativePeriod | BaseTimePeriod;
  selectedModels: string[];
}

export interface ProductsCompareModalTableProps {
  productsCompareKpi: ProductsCompareKpi;
  isLoading: boolean;
  currency: string;
  isApiError?: boolean;
}

export enum ProductsCompareDataRowHeader {
  marketRevenue = 'marketRevenue',
  marketShareRevenue = 'marketShareRevenue',
  marketShareVolume = 'marketShareVolume',
  marketVolume = 'marketVolume',
  marketPrice = 'marketPrice',
  marketRevenueRank = 'marketRevenueRank',
  marketVolumeRank = 'marketVolumeRank',
  retailerRevenue = 'retailerRevenue',
  retailerVolume = 'retailerVolume',
  retailerShareRevenue = 'retailerShareRevenue',
  retailerShareVolume = 'retailerShareVolume',
  retailerMixRevenue = 'retailerMixRevenue',
  retailerMixVolume = 'retailerMixVolume',
  retailerPrice = 'retailerPrice',
  retailerRevenueRank = 'retailerRevenueRank',
  retailerVolumeRank = 'retailerVolumeRank',
}

export const ProductsCompareDataRowHeaderName: Record<ProductsCompareDataRowHeader, string> = {
  [ProductsCompareDataRowHeader.marketRevenueRank]: 'Market Revenue Ranking',
  [ProductsCompareDataRowHeader.marketVolumeRank]: 'Market Units Ranking',
  [ProductsCompareDataRowHeader.marketRevenue]: 'Market Revenue',
  [ProductsCompareDataRowHeader.marketVolume]: 'Market Units',
  [ProductsCompareDataRowHeader.marketShareRevenue]: 'Market Revenue Share',
  [ProductsCompareDataRowHeader.marketShareVolume]: 'Market Units Share',
  [ProductsCompareDataRowHeader.marketPrice]: 'Market Price',
  [ProductsCompareDataRowHeader.retailerRevenueRank]: 'Retailer Revenue Ranking',
  [ProductsCompareDataRowHeader.retailerVolumeRank]: 'Retailer Units Ranking',
  [ProductsCompareDataRowHeader.retailerRevenue]: 'Retailer Revenue',
  [ProductsCompareDataRowHeader.retailerVolume]: 'Retailer Units',
  [ProductsCompareDataRowHeader.retailerShareRevenue]: 'Retailer Revenue Share',
  [ProductsCompareDataRowHeader.retailerShareVolume]: 'Retailer Units Share',
  [ProductsCompareDataRowHeader.retailerMixRevenue]: 'Retailer Revenue Mix',
  [ProductsCompareDataRowHeader.retailerMixVolume]: 'Retailer Units Mix',
  [ProductsCompareDataRowHeader.retailerPrice]: 'Retailer Price',
};

export type ProductsCompareRowHeaderType = Record<ProductsCompareDataRowHeader, string> & {
  firstActivity: string;
};

export type ProductsCompareDataType = Kpi | KpiPercentage | Rank;

export type ProductsCompareDataRowType = {
  headerKey: string;
  data: ProductsCompareDataType;
};

export const ProductsCompareRowHeaderName = {
  firstActivity: 'First Activity',
  ...ProductsCompareDataRowHeaderName,
};

export enum ProductsCompareHeaderTitle {
  DATA = 'Data',
  FEATURES = 'Features',
}

export const FEATURE_UNAVAILABLE = 'Feature information is unavailable';
export const TOTAL_ITEM_NAME = 'TOTAL';
export const MARKET = 'Market ';
export const RETAILER = 'Retailer ';
